import Sidebar from "./shared/sidebar/sidebar.vue";
import { breakPointsHelper } from "@/components/mixin/breakPointsHelpers";

export default {
  mixins: [breakPointsHelper],
  components: {
    Sidebar,
  },
  data() {
    return {
      isSidebarVisible: true,
    };
  },
  beforeMount() {
    this.checkAsideState();
  },
  methods: {
    checkAsideState,
  },
  computed: {
    isMobile() {
      return this.underBreakpoint("md");
    },
  },
  watch: {
    $route: function () {
      this.checkAsideState();
    },
  },
};

function checkAsideState() {
  if (!this.$utils.isMobile()) {
    switch (this.$route.name) {
      case "adminReturnDetails":
      case "dashboardCreateReferral":
      case "createReturnSlip":
      case "reviewReturnSlip":
      case "returnDetails":
      case "createCollection":
      case "editCollection":
      case "createProduct":
      case "editProduct":
      // case 'createBrand':
      // case 'editBrand':
      case "orderDetails":
      case "orderDetailsRetailer":
      case "createPackingSlip":
      case "reviewPackingSlip":
      case "suborderDetails":
      case "invoiceDetails":
      case "editCategory":
      case "reorder":
      case "dashboardCreateAddress":
      case "dashboardEditAddress":
        this.isSidebarVisible = false;
        break;
      default:
        this.isSidebarVisible = true;
    }
  }
}
